import * as React from 'react';
import { useState } from 'react';
import { remove } from 'ramda';
import { icon as Icon, namedCommand } from '../data/icon';
import { amend } from '../../lib/utils';

import * as api from '../api';
import setting from '../setting';

const css = require('./editor.css').default;

export default function ({ icon, onChange, onDelete, onDone }: {
    icon: Icon,
    onChange: (icon: Icon) => void,
    onDelete: () => void,
    onDone: () => void,
}) {
    return (
    <div id={css.main}>
        <IconEditor icon={icon} onChange={onChange}/>
        <hr/>
        <CmdEditor command={icon.command} onChange={command => onChange({ ...icon, command })}/>
        <hr/>
        <div id={css.cmd}>
            <button onClick={onDone}>完成</button>
            <button onClick={onDelete}>刪除</button>
        </div>
    </div>);
}

function IconEditor({ icon, onChange }: {
    icon: Icon,
    onChange: (icon: Icon) => void,
}) {
    const [iconUrls, setIconUrls] = useState<string[] | null>(null);
    const icons = iconUrls?.map(url => {
        return (
        <img
            src={`${setting.補充資料按鈕路徑}${url}`}
            onClick={() => {
                onChange({ ...icon, icon: url });
                setIconUrls(null);
            }}
        />);
    });
    const iconList = icons ? <div id={css.iconList}>{icons}</div> : <></>;
    // pathname = '/' or '/0000'
    const book = new URL(document.location.href).pathname.split('/')[1];

    if (Icon.isBaseIcon(icon)) {
        if (icon.icon === null) {
            return (
            <div>
                {iconList}
                <div>
                    播放聲音的預設圖示
                    <button onClick={() => api.icon.list(book === '' ? null : book).then(setIconUrls)}>換圖示</button>
                </div>
            </div>);
        } else {
            return (
            <div>
                <div>
                    <img src={`${setting.補充資料按鈕路徑}${icon.icon}`} style={{ maxWidth: '100px' }}/>
                </div>
                {iconList}
                <div>
                    <button onClick={() => api.icon.list(book === '' ? null : book).then(setIconUrls)}>換圖示</button>
                    <button onClick={() => onChange({ ...icon, icon: null })}>使用聲音預設圖示</button>
                </div>
            </div>);
        }
    } else {
        return (
        <div>
            <div>長:&nbsp;
                <input type='number' value={icon.height}
                    onChange={e => onChange({ ...icon, height: e.target.valueAsNumber })}
                />
            </div>
            <div>寬:&nbsp;
                <input type='number' value={icon.width}
                    onChange={e => onChange({ ...icon, width: e.target.valueAsNumber })}
                />
            </div>
        </div>);
    }
}

function CmdEditor({ command, onChange }: {
    command: string | namedCommand[],
    onChange: (data: string | namedCommand[]) => void,
}) {
    return (
    <div>
        <div>
            <input type='checkbox' checked={command instanceof Array}
                onChange={e => {
                    if (command instanceof Array) {
                        onChange('');
                    } else {
                        onChange([]);
                    }
                }}
            />&nbsp;選單
        </div>
        {(() => {
            if (command instanceof Array) {
                return (
                <div id={css.dataList}>
                    {(() => {
                        return command.map((cmd, idx) => (
                        <div>
                            <input type='text' placeholder='名稱'
                                value={cmd.name}
                                onChange={e => onChange(amend(command, idx, { ...cmd, name: e.target.value }))}
                            />
                            <input type='text' placeholder='指令'
                                value={cmd.command}
                                onChange={e => onChange(amend(command, idx, { ...cmd, command: e.target.value }))}
                            />
                            <button onClick={() => onChange(remove(idx, 1, command))}>刪</button>
                        </div>));
                    })()}
                    <button onClick={() => onChange(command.concat([{name: '', command: ''}]))}>新增</button>
                </div>);
            } else {
                return (
                <div id={css.data}>
                    <input type='text' size={30} placeholder='指令'
                        value={command}
                        onChange={e => onChange(e.target.value)}
                    />
                </div>);
            }
        })()}
        <div></div>
    </div>);
}
